export const TYPE_CONSIGLIATI = "CONSIGLIATI";
export const TYPE_CATEGORIA = "CATEGORIA";
export const TYPE_CONTINUA    = "CONTINUA A GUARDARE";
export const TYPE_ULTIMI      = "ULTIMI VIDEO";
export const TYPE_FAVORITI    = "FAVORITI";
export const TYPE_PREFERITI="PREFERITI";
export const DEFAULT="https://www.bbrmonza.it/mytv/default.jpg";
